/**
 * Weirwood
 * Copyright 2019 Baidu Inc. All rights reserved.
 *
 * @file try/catch 插件
 * @author zengxiaohui(zengxiaohui@baidu.com)
 */

import {Plugin} from './Plugin';
import {getGlobal} from '../utils/global';
import {fill} from '../utils/fill';
import {wrapTimerFn} from '../utils/wrapper';

export interface TryCatchPluginOptions {
    active: boolean;
}

const global = getGlobal() as Window;
export class TryCatchPlugin implements Plugin {
    static id = 'trycatch';
    name = TryCatchPlugin.id;
    client: any;
    private readonly options: TryCatchPluginOptions;

    constructor(options?: TryCatchPluginOptions) {
        this.options = {
            active: true,
            ...options
        };
    }

    setupOnce(client: any): void {
        this.client = client;

        if (this.options.active) {
            // 使用 try/catch 封装 timer 和事件回调函数，重新抛出异常，拿到 stack 堆栈信息
            fill(global, 'setTimeout', wrapTimerFn, this.client._wrappedBuiltIns);
        }
    }
}
